import Vue from 'vue'
import Vuex from 'vuex'
import { searchService } from "@/services/search.service.js";
import { UrlKeys } from "@/utils/enums";

import {
  SET_COMPANIES, 
  SET_FACETS, 
  SET_PAGINATION,
  SET_SERVICE_REGIONS,
  SET_LIABILITY_INSURANCES,
  SET_SITE_URL_SIGNUP,
  SET_SITE_URL_CONTACT,
  SET_SITE_URL_ABOUT,
  SET_SEARCH_CRIETERIA
} from './mutation-types';

Vue.use(Vuex)

const state = () => ({
  companies: [],
  facets: {},
  pagination:{},
  serviceRegions:[],
  liabilityInsurances:[],
  signUpUrl: null,
  contactUrl:null,
  aboutUrl:null,
  searchCrieteria:{
    corCertified: false,
    wcbCertified: false,
    bondableCompany: false,
    unionAffiliated: false,
    provinceBuckets: [],
    serviceRegionBuckets: [],
    liabilityInsuranceBuckets: [],
    associationBuckets: [],
    selectedCorCertified: false,
    selectedWcbCertified: false,
    selectedBondableCompany: false,
    selectedServiceRegion: null,
    selectedLiabilityInsurance: null,
    location:"",
    keyword: "", 
  }
});

const mutations = {
  [SET_COMPANIES](state, companies) {
    state.companies = companies;    
  },
  [SET_FACETS](state, facets) {
    state.facets = facets;   
  },
  [SET_PAGINATION](state, page) {
    state.pagination  = page;    
  },
  [SET_SERVICE_REGIONS](state, serviceRegions) {
    state.serviceRegions = serviceRegions;    
  },
  [SET_LIABILITY_INSURANCES](state, liabilityinsurances) {
    state.liabilityInsurances = liabilityinsurances;    
  },
  [SET_SITE_URL_SIGNUP](state, url) {
    state.signUpUrl = url;    
  },
  [SET_SITE_URL_CONTACT](state, url) {
    state.contactUrl = url;    
  },
  [SET_SITE_URL_ABOUT](state, url) {
    state.aboutUrl = url;    
  },
  [SET_SEARCH_CRIETERIA](state, searchCrieteria) {
    state.searchCrieteria = {...searchCrieteria};
  }
};
const actions = {
  async fetchCompanies({ commit }, params) {    
    commit(SET_SEARCH_CRIETERIA, params.searchCrieteria);
    const response = await searchService.search(params.url);
    commit(SET_COMPANIES, response.companies);
    commit(SET_PAGINATION, response.pagination);    

    if(params.getFacets)
      commit(SET_FACETS, response.facets);
  },
  async fetchServiceRegions({ commit }, url) {    
    const response = await searchService.serviceRegions(url);
    commit(SET_SERVICE_REGIONS, response);
  },
  async fetchLiabilityInsurances({ commit }, url) {    
    const response = await searchService.liabilityInsurances(url);
    commit(SET_LIABILITY_INSURANCES, response);
  }
  ,
  async fetchSiteUrl({ commit }, urlKey) {  
    let url = `${process.env.VUE_APP_API_URL}api/v1/siteurl/${urlKey}`;  
    const response = await searchService.siteUrl(url);
    switch(urlKey){
      case UrlKeys.L2BSignInUp:
        commit(SET_SITE_URL_SIGNUP, response);
        break;
      case UrlKeys.L2BAbout:
        commit(SET_SITE_URL_ABOUT, response);
        break;
      case UrlKeys.L2BContact:
        commit(SET_SITE_URL_CONTACT, response);
        break;
    }
    
  }
};
export const getters = {
  getCompanies: (state) => state.companies,
  getFacets: (state) => state.facets,
  getPagination: (state) => state.pagination,
  getSearchCrieteria:(state) => state.searchCrieteria, 
};
export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters
})
